import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=b1aa41d2&scoped=true&lang=pug&"
import script from "./login-page.vue?vue&type=script&lang=js&"
export * from "./login-page.vue?vue&type=script&lang=js&"
import style0 from "./login-page.vue?vue&type=style&index=0&id=b1aa41d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa41d2",
  null
  
)

export default component.exports